module.exports = __webpack_public_path__ + "static/media/19ESCAP1.cffe18ec.jpg";